module.exports = __webpack_public_path__ + "static/patryk-karczmarczyk-4b93b7883e1a8ac22fd53bc891da814b.jpg";